/*
* Palo Alto Theme — Cafellow Custom JS
*
* Use this file to add custom Javascript to Palo Alto. Keeping your custom
* Javascript in this file will make it easier to update Palo Alto.
*/

(function() {

  /* ============================================================
     CAFELLOWSHIP MODAL
     ============================================================ */

  var lottieInstances = [];
  var lottieLoaded = false;

  // Carrega a biblioteca Lottie dinamicamente (se ainda não estiver na página)
  function loadLottieLib(callback) {
    if (window.lottie) {
      callback();
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  // Inicializa as animações Lottie nos 4 containers do modal
  function initLottieStars() {
    if (lottieLoaded) return;

    var starUrl = document.querySelector('[data-star-lottie-url]');
    if (!starUrl) return;
    var url = starUrl.getAttribute('data-star-lottie-url');

    var containers = [
      'cfship-lottie-1',
      'cfship-lottie-2',
      'cfship-lottie-3',
      'cfship-lottie-4',
      'cfship-lottie-5',
      'cfship-lottie-6'
    ];

    loadLottieLib(function() {
      containers.forEach(function(id) {
        var el = document.getElementById(id);
        if (!el) return;
        var instance = window.lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: url
        });
        lottieInstances.push(instance);
      });
      lottieLoaded = true;
    });
  }

  function initCafellowshipModal() {
    var overlay = document.getElementById('cfship-modal');
    if (!overlay) return;

    // Closed by default (hidden attribute). Never auto-open — only [data-cfship-open].
    overlay.hidden = true;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');

    function openModal() {
      overlay.hidden = false;
      // Next frame so display:flex is applied before opacity transition / fadein.
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
      });
      document.body.style.overflow = 'hidden';
      initLottieStars();
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Wait for opacity/visibility transition, then hard-hide (no FOUC on next paint).
      var done = false;
      function hide() {
        if (done) return;
        done = true;
        if (!overlay.classList.contains('is-open')) overlay.hidden = true;
      }
      overlay.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 300);
    }

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-cfship-open]')) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
        return;
      }
      if (e.target.closest('.cfship-close')) {
        closeModal();
        return;
      }
      if (e.target === overlay) {
        closeModal();
        return;
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCafellowshipModal);
  } else {
    initCafellowshipModal();
  }


  /* ============================================================
     VARIATION DISPLAY — navegação leve entre sabores
     ============================================================
     Each chip is a normal link, so switching flavour is a full page load AND a
     full replay of the theme's staggered entrance animation. Two cheap wins:

     1. Prefetch the target on hover / touch-start, so by the time the click
        lands the document is usually already cached.
     2. Flag the navigation in sessionStorage. The inline script in
        snippets/head.liquid reads it before paint and adds .sl-nav-quiet, and
        custom.css then skips the entrance animation on arrival — the new
        flavour is simply there instead of re-animating in.
     3. Record where the chip row was sitting on screen. A link navigation
        lands at the top of the document, which on mobile throws the shopper
        well above the row they were tapping — the flavours they were
        comparing are now off-screen and the trail is cut. The inline script
        after the row in snippets/product.liquid puts the row back at the same
        offset, so it holds still while everything around it changes.

        The OFFSET is stored, not the scroll position: the two pages have
        different content above the row (title length, badges, a promotion
        line), so the same scrollY lands somewhere else. Anchoring on the row
        keeps it under the same thumb whatever moved above it.

     Both flags are one-shot and removed on read, so a later normal visit still
     gets the full animation and its own natural scroll position.
     ============================================================ */

  var SL_NAV_KEY = 'sl-variation-nav';
  var SL_ANCHOR_KEY = 'sl-variation-anchor';

  function initVariationNav() {
    var prefetched = Object.create(null);

    function prefetch(url) {
      if (!url || prefetched[url]) return;
      prefetched[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      document.head.appendChild(link);
    }

    // pointerover bubbles (pointerenter does not), so one delegated listener
    // covers chips that are re-rendered or added later.
    document.addEventListener('pointerover', function(e) {
      var chip = e.target.closest && e.target.closest('a.sl-variation');
      if (chip) prefetch(chip.getAttribute('href'));
    });

    document.addEventListener('touchstart', function(e) {
      var chip = e.target.closest && e.target.closest('a.sl-variation');
      if (chip) prefetch(chip.getAttribute('href'));
    }, { passive: true });

    document.addEventListener('click', function(e) {
      var chip = e.target.closest && e.target.closest('a.sl-variation');
      if (!chip) return;
      try {
        sessionStorage.setItem(SL_NAV_KEY, '1');
        var row = chip.closest('.sl-variations');
        if (row) {
          sessionStorage.setItem(SL_ANCHOR_KEY, String(row.getBoundingClientRect().top));
        }
      } catch (err) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariationNav);
  } else {
    initVariationNav();
  }


  /* ============================================================
     PDP PRICE ROW — dock the per-sachê pill beside the old price
     ============================================================

     The studiolab "Unit" block (.sl-unit, "R$ 4,59 / sachê") renders in its own
     product__block AFTER the price, and reaches its spot beside the price by
     being position:absolute with a hand-tuned transform offset — currently
     translate(96px, -42px) from the block's own settings.

     That offset is measured from the BOTTOM of the price block, so it silently
     breaks whenever the price block changes height: reordering the prices, or
     showing the struck-through bundle price, moves the pill off the line it was
     aimed at. It is a coordinate, not a relationship.

     So move the pill's wrapper into the price row itself and let flexbox own the
     relationship. custom.css §9.4 then gives the wrapper display:contents (the
     pill becomes the flex item directly, and the wrapper survives in the DOM so
     the theme editor can still select the block) and resets position/transform,
     which retires the block's own offset settings for this layout.

     The wrapper is moved, not the pill, so its shopify_attributes / data-aos
     ride along with it.
  --------------------------------------------------------------- */
  function dockUnitPill() {
    var pill = document.querySelector('[data-sl-unit]');
    if (!pill) return;

    /* Scope to this product's own price row — snippets/product.liquid renders a
       byte-identical second copy for the quick-view popup. */
    var scope = pill.closest('product-info') || document;
    var row = scope.querySelector('.product__price[data-price-wrapper]');
    if (!row || row.contains(pill)) return;

    row.appendChild(pill.closest('.product__block') || pill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dockUnitPill);
  } else {
    dockUnitPill();
  }


  /* ============================================================
     DRAWER "PESQUISAR" — open the header search popdown
     ============================================================
     Palo Alto intercepts [data-nav-search-open] with preventDefault
     (so the tap never goes to /search) then fires a synthetic
     Event('click') on the header <summary>. Untrusted clicks do
     not toggle <details> in Chromium/Safari, so the popdown never
     opens and the item looks dead. We take over in capture: close
     the drawer, then set details.open so SearchPopdown's native
     'toggle' listener runs SearchPopdown.open().
  */
  function pickSearchPopdown() {
    var candidates = [
      document.querySelector('[data-mobile-menu] search-popdown'),
      document.querySelector('[data-nav-items-compress] search-popdown'),
      document.querySelector('search-popdown[data-popdown-in-header]')
    ];
    var i, el;
    for (i = 0; i < candidates.length; i++) {
      el = candidates[i];
      if (el && el.offsetParent !== null) return el;
    }
    for (i = 0; i < candidates.length; i++) {
      if (candidates[i]) return candidates[i];
    }
    return null;
  }

  function initDrawerSearch() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-nav-search-open]');
      if (!link) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var popdown = pickSearchPopdown();
      var details = popdown && popdown.querySelector('details');
      if (!details) {
        window.location.href = link.getAttribute('href') || '/search';
        return;
      }

      var opened = false;
      function openSearch() {
        if (opened) return;
        opened = true;
        details.open = true;
      }

      var drawer = link.closest('drawer-element');
      if (drawer && drawer.classList.contains('is-open')) {
        var onEnd = function (ev) {
          if (ev.target !== drawer) return;
          drawer.removeEventListener('transitionend', onEnd);
          requestAnimationFrame(openSearch);
        };
        drawer.addEventListener('transitionend', onEnd);
        setTimeout(openSearch, 450);
        drawer.dispatchEvent(new CustomEvent('theme:drawer:toggle', {
          detail: { trigger: link }
        }));
      } else {
        openSearch();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerSearch);
  } else {
    initDrawerSearch();
  }

})();
/* Loop bundle: "Remover" on the clubbed bundle row removes every line of that bundle */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-bundle-remove]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();

    var updates = {};
    (link.getAttribute('data-keys') || '').split(',').forEach(function (key) {
      if (key) updates[key] = 0;
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      window.location.reload();
    });
  }, true);
})();